export default __webpack_public_path__ + "static/media/successNoProductModal.c1bc8d0a.svg";